import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import Question from './components/testQuestion.vue'
import Score from './components/Score.vue'
import Camera from "./components/Camera";
import NotFound from "./components/404";
import Sjerr from "./components/Sj_err";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/:t?',
      component: Home
    },
    {
      path: '/camera',
      component: Camera
    },
    {
      path: '/question/:sj_id?',
      component: Question
    },
    {
      path: '/score/:sj_id',
      component: Score
    },
    {
      path: '/sje',
      component: Sjerr
    },
    { path: '*', component: NotFound },
    {
      path: '/w_index',
      component: () => import('./components/w_index.vue')
    },
    {
      path: '/audio',
      component: () => import('./components/Audio.vue')
    },
    {
      path: '/faceDetect/:sj_id',
      component: () => import('./components/FacePhoto.vue')
    },
    {
      path: '/testFacePhoto/:sj_id',
      component: () => import('./components/testFacePhoto.vue')
    },
    {
      path: '/testScore/:sj_id',
      component: () => import('./components/testScore.vue')
    },
    {
      path: '/video',
      component: () => import('./components/Video.vue')
    }
  ]
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 获取路由参数
  const t = to.params.t;
  var title = '';
  if (t) {
    switch (t) {
      case 'u':
        title = '大学生心理健康多模态情绪综合测评量表(MQ69)';
        break;
      case 'h':
        title = '高中生心理健康多模态情绪综合测评量表(MQ69)';
        break;
      default:
        break;
    }
  }
  // 更新页面标题
  document.title = title || '心理健康多模态情绪综合测评量表(MQ69)';
  next();
});

export default router;
